// extracted by mini-css-extract-plugin
export default {"pills":"_1qxehip","dropdownTrigger":"_1fwcsce","dropdownContent":"_e4shtr","dropdownSectionTitle":"_1oo2ctp","dropdownDivider":"_q34cm7"};